module.exports = {
    getStates: function() {
        return [
// #region UNITED STATES
            {
                "name": "Alabama",
                "abbreviation": "AL"
            },
            {
                "name": "Alaska",
                "abbreviation": "AK"
            },
            {
                "name": "American Samoa",
                "abbreviation": "AS"
            },
            {
                "name": "Arizona",
                "abbreviation": "AZ"
            },
            {
                "name": "Arkansas",
                "abbreviation": "AR"
            },
            {
                "name": "California",
                "abbreviation": "CA"
            },
            {
                "name": "Colorado",
                "abbreviation": "CO"
            },
            {
                "name": "Connecticut",
                "abbreviation": "CT"
            },
            {
                "name": "Delaware",
                "abbreviation": "DE"
            },
            {
                "name": "District Of Columbia",
                "abbreviation": "DC"
            },            
            {
                "name": "Florida",
                "abbreviation": "FL"
            },
            {
                "name": "Georgia",
                "abbreviation": "GA"
            },
            {
                "name": "Guam",
                "abbreviation": "GU"
            },
            {
                "name": "Hawaii",
                "abbreviation": "HI"
            },
            {
                "name": "Idaho",
                "abbreviation": "ID"
            },
            {
                "name": "Illinois",
                "abbreviation": "IL"
            },
            {
                "name": "Indiana",
                "abbreviation": "IN"
            },
            {
                "name": "Iowa",
                "abbreviation": "IA"
            },
            {
                "name": "Kansas",
                "abbreviation": "KS"
            },
            {
                "name": "Kentucky",
                "abbreviation": "KY"
            },
            {
                "name": "Louisiana",
                "abbreviation": "LA"
            },
            {
                "name": "Maine",
                "abbreviation": "ME"
            },
            {
                "name": "Marshall Islands",
                "abbreviation": "MH"
            },
            {
                "name": "Maryland",
                "abbreviation": "MD"
            },
            {
                "name": "Massachusetts",
                "abbreviation": "MA"
            },
            {
                "name": "Michigan",
                "abbreviation": "MI"
            },
            {
                "name": "Minnesota",
                "abbreviation": "MN"
            },
            {
                "name": "Mississippi",
                "abbreviation": "MS"
            },
            {
                "name": "Missouri",
                "abbreviation": "MO"
            },
            {
                "name": "Montana",
                "abbreviation": "MT"
            },
            {
                "name": "Nebraska",
                "abbreviation": "NE"
            },
            {
                "name": "Nevada",
                "abbreviation": "NV"
            },
            {
                "name": "New Hampshire",
                "abbreviation": "NH"
            },
            {
                "name": "New Jersey",
                "abbreviation": "NJ"
            },
            {
                "name": "New Mexico",
                "abbreviation": "NM"
            },
            {
                "name": "New York",
                "abbreviation": "NY"
            },
            {
                "name": "North Carolina",
                "abbreviation": "NC"
            },
            {
                "name": "North Dakota",
                "abbreviation": "ND"
            },
            {
                "name": "Ohio",
                "abbreviation": "OH"
            },
            {
                "name": "Oklahoma",
                "abbreviation": "OK"
            },
            {
                "name": "Oregon",
                "abbreviation": "OR"
            },
            {
                "name": "Palau",
                "abbreviation": "PW"
            },
            {
                "name": "Pennsylvania",
                "abbreviation": "PA"
            },
            {
                "name": "Puerto Rico",
                "abbreviation": "PR"
            },
            {
                "name": "Rhode Island",
                "abbreviation": "RI"
            },
            {
                "name": "South Carolina",
                "abbreviation": "SC"
            },
            {
                "name": "South Dakota",
                "abbreviation": "SD"
            },
            {
                "name": "Tennessee",
                "abbreviation": "TN"
            },
            {
                "name": "Texas",
                "abbreviation": "TX"
            },
            {
                "name": "Utah",
                "abbreviation": "UT"
            },
            {
                "name": "Vermont",
                "abbreviation": "VT"
            },
            {
                "name": "Virgin Islands",
                "abbreviation": "VI"
            },
            {
                "name": "Virginia",
                "abbreviation": "VA"
            },
            {
                "name": "Washington",
                "abbreviation": "WA"
            },
            {
                "name": "West Virginia",
                "abbreviation": "WV"
            },
            {
                "name": "Wisconsin",
                "abbreviation": "WI"
            },
            {
                "name": "Wyoming",
                "abbreviation": "WY"
            },
// #endregion UNITED STATES

// #region CANADA
            {
              "name": "Alberta",
              "abbreviation": "AB"
            },
            {
              "name": "British Columbia",
              "abbreviation": "BC"
            },
            {
              "name": "Manitoba",
              "abbreviation": "MB"
            },
            {
              "name": "New Brunswick",
              "abbreviation": "NB"
            },
            {
              "name": "Newfoundland and Labrador",
              "abbreviation": "NL"
            },
            {
              "name": "Nova Scotia",
              "abbreviation": "NS"
            },
            {
              "name": "Northwest Territories",
              "abbreviation": "NT"
            },
            {
              "name": "Nunavut",
              "abbreviation": "NU"
            },
            {
              "name": "Ontario",
              "abbreviation": "ON"
            },
            {
              "name": "Prince Edward Island",
              "abbreviation": "PE"
            },
            {
              "name": "Quebec",
              "abbreviation": "QC"
            },
            {
              "name": "Saskatchewan",
              "abbreviation": "SK"
            },
            {
              "name": "Yukon",
              "abbreviation": "YT"
            },
//   #endregion CANADA

//  #region UNITED KINGDOM
{
    "name": "Aberdeen",
    "abbreviation": "AB"
  },
  {
    "name": "St Albans",
    "abbreviation": "AL"
  },
  {
    "name": "Bath",
    "abbreviation": "B"
  },
  {
    "name": "Bournemouth",
    "abbreviation": "BH"
  },
  {
    "name": "Blackburn",
    "abbreviation": "BB"
  },
  {
    "name": "Bradford",
    "abbreviation": "BD"
  },
  {
    "name": "Bradford",
    "abbreviation": "BF"
  },
  {
    "name": "Bournemouth",
    "abbreviation": "BH"
  },
  {
    "name": "Bolton",
    "abbreviation": "BL"
  },
  {
    "name": "Brighton",
    "abbreviation": "BN"
  },
  {
    "name": "Bromley",
    "abbreviation": "BR"
  },
  {
    "name": "Bristol",
    "abbreviation": "BS"
  },
  {
    "name": "Belfast",
    "abbreviation": "BT"
  },
  {
    "name": "Brixton",
    "abbreviation": "BX"
  },
  {
    "name": "Carlisle",
    "abbreviation": "CA"
  },
  {
    "name": "Cambridge",
    "abbreviation": "CB"
  },
  {
    "name": "Cardiff",
    "abbreviation": "CF"
  },
  {
    "name": "Chester",
    "abbreviation": "CH"
  },
  {
    "name": "Chelmsford",
    "abbreviation": "CM"
  },
  {
    "name": "Colchester",
    "abbreviation": "CO"
  },
  {
    "name": "Croydon",
    "abbreviation": "CR"
  },
  {
    "name": "Canterbury",
    "abbreviation": "CT"
  },
  {
    "name": "Coventry",
    "abbreviation": "CV"
  },
  {
    "name": "Crewe",
    "abbreviation": "CW"
  },
  {
    "name": "Dartford",
    "abbreviation": "DA"
  },
  {
    "name": "Dundee",
    "abbreviation": "DD"
  },
  {
    "name": "Derby",
    "abbreviation": "DE"
  },
  {
    "name": "Dumfries",
    "abbreviation": "DG"
  },
  {
    "name": "Durham",
    "abbreviation": "DH"
  },
  {
    "name": "Darlington",
    "abbreviation": "DL"
  },
  {
    "name": "Doncaster",
    "abbreviation": "DN"
  },
  {
    "name": "Dorchester",
    "abbreviation": "DT"
  },
  {
    "name": "Dudley",
    "abbreviation": "DY"
  },
  {
    "name": "East London",
    "abbreviation": "E"
  },
  {
    "name": "London",
    "abbreviation": "EC"
  },
  {
    "name": "Edinburgh",
    "abbreviation": "EH"
  },
  {
    "name": "Enfield",
    "abbreviation": "EN"
  },
  {
    "name": "Exeter",
    "abbreviation": "EX"
  },
  {
    "name": "Falkirk",
    "abbreviation": "FK"
  },
  {
    "name": "Fylde",
    "abbreviation": "FY"
  },
  {
    "name": "Glasgow",
    "abbreviation": "G"
  },
  {
    "name": "Gloucester",
    "abbreviation": "GL"
  },
  {
    "name": "Guildford",
    "abbreviation": "GU"
  },
  {
    "name": "Guernsey",
    "abbreviation": "GY"
  },
  {
    "name": "Harrow",
    "abbreviation": "HA"
  },
  {
    "name": "Huddersfield",
    "abbreviation": "HD"
  },
  {
    "name": "Harrogate",
    "abbreviation": "HG"
  },
  {
    "name": "Hemel Hempstead",
    "abbreviation": "HP"
  },
  {
    "name": "Hereford",
    "abbreviation": "HR"
  },
  {
    "name": "Harris",
    "abbreviation": "HS"
  },
  {
    "name": "Hull",
    "abbreviation": "HU"
  },
  {
    "name": "Halifax",
    "abbreviation": "HX"
  },
  {
    "name": "Ilford",
    "abbreviation": "IG"
  },
  {
    "name": "Isle of Man",
    "abbreviation": "IM"
  },
  {
    "name": "Ipswich",
    "abbreviation": "IP"
  },
  {
    "name": "Inverness",
    "abbreviation": "IV"
  },
  {  
    "name": "Jersey",
    "abbreviation": "JE"
  },
  {
    "name": "Kilmarnock",
    "abbreviation": "KA"
  },
  {
    "name": "Kingston upon Thames",
    "abbreviation": "KT"
  },
  {
    "name": "Kirkwall",
    "abbreviation": "KW"
  },
  {
    "name": "Kirkcaldy",
    "abbreviation": "KY"
  },
  {
    "name": "Lerwick",
    "abbreviation": "L"
  },
  {
    "name": "Glasgow (GIR)",
    "abbreviation": "GIR"
  },
{
    "name": "Lancaster",
    "abbreviation": "LA"
},
{
    "name": "Llandrindod Wells",
    "abbreviation": "LD"
},
{
    "name": "Leicester",
    "abbreviation": "LE"
},
{
    "name": "Llandudno",
    "abbreviation": "LL"
},
{
    "name": "Lincoln",
    "abbreviation": "LN"
},
{
    "name": "Leeds",
    "abbreviation": "LS"
},
{
    "name": "Luton",
    "abbreviation": "LU"
},
{
    "name": "Manchester",
    "abbreviation": "M"
},
{
    "name": "Medway",
    "abbreviation": "ME"
},
{
    "name": "Milton Keynes",
    "abbreviation": "MK"
},
{
    "name": "Motherwell",
    "abbreviation": "ML"
},
{
    "name": "North London",
    "abbreviation": "N"
},
{
    "name": "Newcastle upon Tyne",
    "abbreviation": "NE"
},
{
    "name": "Nottingham",
    "abbreviation": "NG"
},
{
    "name": "Northampton",
    "abbreviation": "NN"
},
{
    "name": "Newport",
    "abbreviation": "NP"
},
{
    "name": "Norwich",
    "abbreviation": "NR"
},
{
    "name": "North West London",
    "abbreviation": "NW"
},
{
    "name": "Oldham",
    "abbreviation": "OL"
},
{
    "name": "Oxford",
    "abbreviation": "OX"
},
{
    "name": "Paisley",
    "abbreviation": "PA"
},
{
    "name": "Peterborough",
    "abbreviation": "PE"
},
{
    "name": "Perth",
    "abbreviation": "PH"
},
{
    "name": "Plymouth",
    "abbreviation": "PL"
},
{
    "name": "Portsmouth",
    "abbreviation": "PO"
},
{
    "name": "Preston",
    "abbreviation": "PR"
},
{
    "name": "Reading",
    "abbreviation": "RG"
},
{
    "name": "Redhill",
    "abbreviation": "RH"
},
{
    "name": "Romford",
    "abbreviation": "RM"
},
{
    "name": "Sheffield",
    "abbreviation": "S"
},
{
    "name": "Swansea",
    "abbreviation": "SA"
},
{
    "name": "South East London",
    "abbreviation": "SE"
},
{
    "name": "Stevenage",
    "abbreviation": "SG"
},
{
    "name": "Stockport",
    "abbreviation": "SK"
},
{
    "name": "Slough",
    "abbreviation": "SL"
},
{
    "name": "Sutton",
    "abbreviation": "SM"
},
{
    "name": "Swindon",
    "abbreviation": "SN"
},
{
    "name": "Southampton",
    "abbreviation": "SO"
},
{
    "name": "Salisbury",
    "abbreviation": "SP"
},
{
    "name": "Sunderland",
    "abbreviation": "SR"
},
{
    "name": "Southend-on-Sea",
    "abbreviation": "SS"
},
{
    "name": "Stoke-on-Trent",
    "abbreviation": "ST"
},
{
    "name": "South West London",
    "abbreviation": "SW"
},
{
    "name": "Shrewsbury",
    "abbreviation": "SY"
},
{
    "name": "Taunton",
    "abbreviation": "TA"
},
{
    "name": "Galashiels",
    "abbreviation": "TD"
},
{
    "name": "Telford",
    "abbreviation": "TF"
},
{
    "name": "Tonbridge",
    "abbreviation": "TN"
},
{
    "name": "Torquay",
    "abbreviation": "TQ"
},
{
    "name": "Truro",
    "abbreviation": "TR"
},
{
    "name": "Teesside",
    "abbreviation": "TS"
},
{
    "name": "Twickenham",
    "abbreviation": "TW"
},
{
    "name": "Uxbridge",
    "abbreviation": "UB"
},
{
    "name": "West London",
    "abbreviation": "W"
},
{
    "name": "Warrington",
    "abbreviation": "WA"
},
{
    "name": "West Central London",
    "abbreviation": "WC"
},
{
    "name": "Watford",
    "abbreviation": "WD"
},
{
    "name": "Wakefield",
    "abbreviation": "WF"
},
{
    "name": "Wigan",
    "abbreviation": "WN"
},
{
    "name": "Worcester",
    "abbreviation": "WR"
},
{
    "name": "Walsall",
    "abbreviation": "WS"
},
{
    "name": "Wolverhampton",
    "abbreviation": "WV"
},
{
    "name": "York",
    "abbreviation": "YO"
},
{
    "name": "Lerwick",
    "abbreviation": "ZE"
}
// #endregion UNITED KINGDOM

        ];
    }
}